import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface FeedbackState {
  lastCSATShownTimestamp: number | null; // Unix timestamp in milliseconds
}

const initialState: FeedbackState = {
  lastCSATShownTimestamp: null,
};

export const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    setLastCSATShownTimestamp: (state, action: PayloadAction<number>) => {
      state.lastCSATShownTimestamp = action.payload;
    },
  },
});

export const { setLastCSATShownTimestamp } = feedbackSlice.actions;

export default feedbackSlice.reducer;
